import React, { useEffect } from 'react';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

type Props = {
	title: string;
	pageClass: string;
	linkOne: string;
	customerCare?: boolean;
};

const SubHeader = ({ title, pageClass, linkOne, customerCare }: Props) => {
	// TODO: handle this all in React hooks
	useEffect(() => {
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.intersectionRatio > 0) {
					const id = entry.target.id,
						subNavClass = document.querySelector(`.${id}-subnav`);

					if (subNavClass) {
						document.querySelectorAll('.sub-nav li').forEach(elem => elem.classList.remove('active'));
						subNavClass.classList.add('active');
					} else {
						document.querySelectorAll('.sub-nav li').forEach(elem => elem.classList.remove('active'));
					}
				}
			});
		});

		document.querySelectorAll('.division-container > div').forEach(title => {
			observer.observe(title);
		});

		return () => observer.disconnect();
	}, []);

	const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';

	if (title === 'OmniWatch') {
		return (
			<div id="sub-header">
				<div className="container-1200">
					<p>{title}</p>
					<div className="sub-nav">
						<ul className={pageClass}>
							<li className="jobs-container-subnav">
								<AnchorLink to={`${currentPath}#product`} title="Product" /> <span></span>
							</li>
						</ul>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div id="sub-header">
			<div className="container-1200">
				<p>{title}</p>
				<div className="sub-nav">
					<ul className={pageClass}>
						{customerCare ? (
							<li className="what-we-do-subnav">
								<AnchorLink to={`${currentPath}#what-we-do`} title="About" /> <span></span>
							</li>
						) : (
							<li className="product-subnav">
								<AnchorLink to={`${currentPath}#product`} title={linkOne} /> <span></span>
							</li>
						)}
						<li className="team-subnav">
							<AnchorLink to={`${currentPath}#team`} title={customerCare ? 'Management' : 'Team'} /> <span></span>
						</li>
						<li className="culture-subnav">
							<AnchorLink to={`${currentPath}#culture`} title="Culture" /> <span></span>
						</li>
						<li className="benefits-subnav">
							<AnchorLink to={`${currentPath}#benefits`} title="Benefits" /> <span></span>
						</li>
						<li className="jobs-container-subnav">
							<AnchorLink to={`${currentPath}#jobs-container`} title="Careers" /> <span></span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
};

export default SubHeader;
